<mat-toolbar color="primary">
    Login
    <span class="flex-spacer"></span>
    <button mat-button mat-dialog-close>&times;</button>
</mat-toolbar>

<!-- <p>{{ user | json}}</p> -->

<form novalidate #loginForm="ngForm" (ngSubmit)="OnSubmit()">
    <mat-dialog-content>
        <p class="first-para">
            <mat-form-field>
                <input matInput placeholder="Username" #username="ngModel" type="text" [(ngModel)]="user.username" name="username" required>
                <mat-error *ngIf="username.errors?.required">Username is required</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field>
                <input matInput placeholder="Password" #password="ngModel" type="password" [(ngModel)]="user.password" name="password" required>
                <mat-error *ngIf="password.errors?.required">Password is required</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-checkbox [(ngModel)]="user.remember" name="remember">Remember Me</mat-checkbox>
        </p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <span class="flex-spacer"></span>
        <button mat-button mat-dialog-close>Cancle</button>
        <button mat-button type="submit" [disabled]="loginForm.form.invalid" class="background-primary text-floral-white">Login</button>
    </mat-dialog-actions>
</form>